<form [formGroup]="form">
  <glxy-form-field>
    <glxy-label>{{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.SEND_FROM' | translate }}</glxy-label>
    <mat-radio-group formControlName="sendFromDefault">
      <mat-radio-button value="partner-domain" [disabled]="disableUserDomainSelection$ | async">
        {{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.PARTNER_DOMAIN' | translate }} {{ userDomain$ | async }}
        <ng-container *ngIf="disableUserDomainSelection$ | async"></ng-container>
        <extended>
          Authorize your own domain from the
          <a [routerLink]="emailSettingsRouterLink">email settings page</a>
        </extended>
      </mat-radio-button>
      <mat-radio-button value="default-domain">
        {{ 'USERS.RESEND_WELCOME_EMAIL_MODAL.DEFAULT_DOMAIN' | translate }} ({{ defaultDomain$ | async }})
        <extended>Use this non-branded domain if your domain is not working</extended>
      </mat-radio-button>
    </mat-radio-group>
  </glxy-form-field>
</form>
